import React from 'react';
export function Privacy() {
  return <div className="max-w-3xl mx-auto px-6 pt-32 pb-24" data-id="element-11280" data-mp="lkqlmuwh2pqz">
      <h1 className="text-4xl font-bold text-[#2B211A] mb-8 font-title tracking-tight" data-id="element-11281" data-mp="2wk6z5qsa29fr">
        Privacy Policy
      </h1>

      <div className="space-y-8 text-neutral-600 font-body leading-relaxed" data-id="element-11282" data-mp="3b9ml8tgv5qp4">
        <section data-id="element-11283" data-mp="36hbb6xsesoiu">
          <p className="text-lg text-neutral-700" data-id="element-11284" data-mp="36gtgw6pb4kdk">
            This Privacy Policy explains how Giga collects, uses, discloses, and
            safeguards your information when you visit our website or use our
            service (the &quot;Service&quot;), and describes your privacy rights and
            how the law protects you. By using the Service, you agree to the
            collection and use of information in accordance with this Policy.
          </p>
        </section>

        <section data-id="element-11285" data-mp="1zswf1acfwyvi">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11286" data-mp="1zufw335x7dyc">
            1. Who We Are &amp; Key Definitions
          </h2>
          <p className="mb-4" data-id="element-11287" data-mp="h25ydt7gar37">
            Giga is operated by <strong data-id="element-11288" data-mp="h3qv9ph8mm48">Tonic Labs Limited</strong>, a company
            registered in Ireland (&quot;Giga&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;). For the
            purposes of the EU General Data Protection Regulation (GDPR) and the
            UK GDPR, Tonic Labs Limited is the <strong data-id="element-11289" data-mp="uuchno5whe6v">Data Controller</strong> of
            personal data processed through the Service. You can contact us about
            privacy at{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-11290" data-mp="14rqnyuy40mlg">
              support@getgiga.com
            </a>
            .
          </p>
          <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-11291" data-mp="18riy3c35j0sx">
            <li data-id="element-11292" data-mp="1dr5axkf2if17">
              <strong data-id="element-11293" data-mp="1drnfr5fsq1kq">Personal Data</strong> — any information relating to an
              identified or identifiable individual.
            </li>
            <li data-id="element-11294" data-mp="3fjjns52r8tar">
              <strong data-id="element-11295" data-mp="3fj08yx8eil0y">Usage Data</strong> — data collected automatically from
              your use of the Service (e.g. IP address, browser type, pages
              visited, timestamps).
            </li>
            <li data-id="element-11296" data-mp="hr9xaojwicl6">
              <strong data-id="element-11297" data-mp="hrt3j806vcjd">Connected-Service Data</strong> — data we access from a
              third-party service you connect (e.g. Google Workspace, Slack) on
              your instruction, solely to carry out your requests.
            </li>
            <li data-id="element-11298" data-mp="15o790gdjei8d">
              <strong data-id="element-11299" data-mp="15nnoqt0ezhr6">Service Provider / Processor</strong> — a third party that
              processes data on our behalf under contract.
            </li>
          </ul>
        </section>

        <section data-id="element-11300" data-mp="1eghg3ot4y7le">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11301" data-mp="1eh0syr3xi5sk">
            2. Information We Collect
          </h2>
          <p className="mb-4" data-id="element-11302" data-mp="1afp62tcfvyo2">
            <strong data-id="element-11303" data-mp="1oef5wgqn8cg4">Information you provide.</strong> When you create an account,
            connect integrations, or communicate with us, we collect information
            such as your name, email address, workspace configuration, and any
            content you submit through the Service.
          </p>
          <p className="mb-4" data-id="element-11304" data-mp="28071vemt7niv">
            <strong data-id="element-11305" data-mp="27z5nb06l4iwe">Information collected automatically.</strong> When you use the
            Service we automatically collect Usage Data, including your IP
            address, device and browser type, the pages you visit, and the time
            and duration of your visit.
          </p>
          <p className="mb-4" data-id="element-11306" data-mp="1k9utk2nnjorr">
            <strong data-id="element-11307" data-mp="1k9l36dyp3flj">Connected-Service Data.</strong> When you connect a
            third-party integration (including Google Workspace, Gmail, Google
            Drive, Google Docs, Google Calendar, and Slack), we access and process
            data from those services <em data-id="element-11308" data-mp="1fb02yejg0vx3">only</em> to fulfil the specific requests
            you make and to provide the Service&apos;s functionality. See Section 5
            for exactly what Google data we access and why.
          </p>
        </section>

        <section data-id="element-11309" data-mp="15d3opdv7lkur">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11310" data-mp="15fq1pt0vcskd">
            3. Cookies, Analytics &amp; Tracking
          </h2>
          <p className="mb-4" data-id="element-11311" data-mp="tcdmzashw1nl">
            Our website uses cookies and similar technologies to operate the site
            and understand how it is used. These website analytics are entirely
            separate from — and never draw on — the Google user data described in
            Section 5. We use:
          </p>
          <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-11312" data-mp="fl8rmkw5tvj2">
            <li data-id="element-11313" data-mp="akb8a4zeyvfz">
              <strong data-id="element-11314" data-mp="ajt8wzhgg13u">Google Analytics</strong> — to measure website traffic and
              usage patterns.
            </li>
            <li data-id="element-11315" data-mp="5lzzzyoroszv">
              <strong data-id="element-11316" data-mp="5nkujob30bxq">PostHog</strong> — for product analytics, to understand how
              features are used and improve them.
            </li>
            <li data-id="element-11317" data-mp="1zypuoimym68b">
              <strong data-id="element-11318" data-mp="1zz91p4b2na7k">Reditus</strong> — to attribute referrals from our affiliate
              programme.
            </li>
          </ul>
          <p className="mb-4" data-id="element-11319" data-mp="1uyv127bsv2jk">
            Cookies may be &quot;session&quot; cookies (deleted when you close your browser)
            or &quot;persistent&quot; cookies (which remain until they expire or you delete
            them). You can instruct your browser to refuse cookies or alert you
            when one is set; some parts of the Service may not function properly
            without them. Where required by law, we ask for your consent before
            setting non-essential cookies. We honour recognised browser-based
            opt-out signals (including Global Privacy Control) where applicable.
          </p>
        </section>

        <section data-id="element-11320" data-mp="1tihehuacinmy">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11321" data-mp="1thxvea8ylt7c">
            4. How We Use Your Information &amp; Legal Bases
          </h2>
          <p className="mb-4" data-id="element-11322" data-mp="34xmg0uyqqg4z">
            We use your information to provide, maintain, secure, and improve the
            Service; to carry out the actions you request; to manage your account;
            to communicate with you about the Service; and to comply with our
            legal obligations. Under the GDPR, we rely on the following legal
            bases:
          </p>
          <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-11323" data-mp="2u8cf3ktmkwwe">
            <li data-id="element-11324" data-mp="2u5q75k2tofdn">
              <strong data-id="element-11325" data-mp="2p8q1vbdsrgnl">Performance of a contract</strong> — to provide the Service
              and carry out the tasks you ask Giga to perform.
            </li>
            <li data-id="element-11326" data-mp="21jn9b8hmk3eb">
              <strong data-id="element-11327" data-mp="21h161l1roa1w">Legitimate interests</strong> — to secure, maintain, and
              improve the Service and understand how it is used, balanced against
              your rights.
            </li>
            <li data-id="element-11328" data-mp="2bb1e9vschveu">
              <strong data-id="element-11329" data-mp="26i89x90sgp3a">Consent</strong> — for non-essential cookies and optional
              communications, which you may withdraw at any time.
            </li>
            <li data-id="element-11330" data-mp="1iqt6fcxa01qg">
              <strong data-id="element-11331" data-mp="1iqjhlsnyw0mc">Legal obligation</strong> — where we must process data to
              comply with the law.
            </li>
          </ul>
        </section>

        <section data-id="element-11332" data-mp="3pg4mn0rgvrzt">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11333" data-mp="3pflegbrmchyz">
            5. Google User Data &amp; Limited Use
          </h2>
          <p className="mb-4" data-id="element-11334" data-mp="3fji3qhipbb0f">
            Giga&apos;s use of information received from Google APIs will adhere to
            the{' '}
            <a href="https://developers.google.com/terms/api-services-user-data-policy" className="text-[#EA580C] hover:underline font-medium" target="_blank" rel="noopener noreferrer" data-id="element-11335" data-mp="3ki34ci1v7wpe">
              Google API Services User Data Policy
            </a>
            , including the Limited Use requirements.
          </p>
          <p className="mb-4" data-id="element-11336" data-mp="33o6uchpne9o">
            We request the narrowest scopes needed to provide the features you
            ask for. Specifically:
          </p>
          <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-11337" data-mp="2nqrfat79eqlq">
            <li data-id="element-11338" data-mp="2rsw6zme5dd5q">
              <strong data-id="element-11339" data-mp="2rtebt7evkzp9">Gmail (<code data-id="element-11340" data-mp="2ru779c8dw2s3">gmail.modify</code>)</strong> — read the content
              and labels of messages you point Giga to, and, on your instruction,
              compose, send, draft, label, archive, and organise mail. We do not
              request permanent-deletion or full-account scopes.
            </li>
            <li data-id="element-11341" data-mp="3agu30ewjx85d">
              <strong data-id="element-11342" data-mp="3agaprbhuj7xo">Google Drive (<code data-id="element-11343" data-mp="35gxuq3gtmuk0">drive</code>)</strong> — find, read,
              create, edit, move, and share files you ask Giga to act on,
              including files you did not create, so Giga can act on your existing
              content by description.
            </li>
            <li data-id="element-11344" data-mp="20r0enkaq9nw">
              <strong data-id="element-11345" data-mp="22bwihm9e0nv">Google Docs (<code data-id="element-11346" data-mp="3tewrmsl6t32n">documents</code>)</strong> — read and edit
              the body content of documents you ask Giga to work on (insert,
              rewrite, restructure, or summarise sections in place).
            </li>
            <li data-id="element-11347" data-mp="pq1vppivnbun">
              <strong data-id="element-11348" data-mp="pqlfzcw02cbu">Google Calendar (<code data-id="element-11349" data-mp="pr4mzyk43gb3">calendar.events</code>)</strong> — read
              your schedule and create, update, or cancel individual events on
              your instruction. We do not request broader calendar-settings
              scopes.
            </li>
          </ul>
          <p className="mb-4" data-id="element-11350" data-mp="xadu1l55b2wz">
            Google user data is accessed only when you ask Giga to act on it, used
            solely to compose the response or perform the action you requested,
            and not retained afterwards. We do <strong data-id="element-11351" data-mp="16bc3wk29m4nh">not</strong> use Google user
            data for advertising or targeting, and we do <strong data-id="element-11352" data-mp="1b8kjccw13ul1">not</strong> use
            it to develop, improve, or train generalised AI/ML models. Any transfer
            to a third party is limited to what is necessary to provide the Service
            at your direction (see Section 6) or as required by law.
          </p>
        </section>

        <section data-id="element-11353" data-mp="1px6yadhqukbq">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11354" data-mp="1pzt52awt8vsw">
            6. How We Share Your Information &amp; Subprocessors
          </h2>
          <p className="mb-4" data-id="element-11355" data-mp="1yyy4rkk3yv6n">
            We do <strong data-id="element-11356" data-mp="1ria96ctrurht">not</strong> sell your personal data. We share it only
            with service providers who process it on our behalf under contract, and
            only as needed to run the Service:
          </p>
          <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-11357" data-mp="21fognmxpw5xz">
            <li data-id="element-11358" data-mp="21e4z7t0broum">
              <strong data-id="element-11359" data-mp="266y1894esj30">AI model provider — Anthropic, PBC.</strong> To carry out
              your requests, relevant content may be sent as ephemeral context to
              Anthropic&apos;s Claude models. Under Anthropic&apos;s commercial API
              terms, this data is <strong data-id="element-11360" data-mp="2f5rubpij6rbt">not used to train their models</strong>
              and is not retained beyond what is needed to return the response.
            </li>
            <li data-id="element-11361" data-mp="2p628bcce42s1">
              <strong data-id="element-11362" data-mp="2p4hczki94ft4">Cloud hosting &amp; infrastructure — Hetzner (EU).</strong>{' '}
              Hosts the application and database within the EU.
            </li>
            <li data-id="element-11363" data-mp="urhp743pwfar">
              <strong data-id="element-11364" data-mp="uqzo9u641cwi">Backup storage — Cloudflare R2 (EU).</strong> Encrypted
              database backups are stored in EU-based object storage.
            </li>
            <li data-id="element-11365" data-mp="33bcaiunnyqmm">
              <strong data-id="element-11366" data-mp="33bkkoesejhu4">Analytics providers</strong> — Google Analytics, PostHog, and
              Reditus, for website and product analytics only (never Google user
              data).
            </li>
          </ul>
          <p className="mb-4" data-id="element-11367" data-mp="2ubfh6fqbx3l8">
            We may also disclose data in connection with a merger, acquisition, or
            asset sale (with notice), or as described in Section 10.
          </p>
        </section>

        <section data-id="element-11368" data-mp="3n0mpg6fl57jo">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11369" data-mp="3n036cme78d42">
            7. Data Security &amp; AI Processing
          </h2>
          <p className="mb-4" data-id="element-11370" data-mp="3d1x6sbfv7j2d">
            We implement appropriate technical and organisational security
            measures designed to protect your information, including encryption at
            rest and in transit. No method of transmission or storage is 100%
            secure, but we work to protect your data using commercially acceptable
            means.
          </p>
          <p className="mb-4" data-id="element-11371" data-mp="281ywqru5ao5i">
            Giga uses a vault-proxy architecture for all third-party integrations.
            When you connect a service (e.g. Gmail, Google Drive, Slack), your
            credentials — API keys, OAuth tokens, and other secrets — are stored
            encrypted in a dedicated vault and are never exposed to our AI models
            or placed into model context. All authenticated requests are proxied
            through the vault, which injects the credential server-side so the raw
            secret never reaches the application layer.
          </p>
          <p className="mb-4" data-id="element-11372" data-mp="1fdjmeilyku0i">
            When you ask Giga to act on connected data (e.g. summarise an email,
            find a file), the relevant content may be passed as ephemeral context
            to an LLM solely to fulfil your request. This processing is transient:
            context is not stored after the response is generated, and we do not
            train foundational AI models on your private data, chat history, or
            connected-service content. Your data remains yours.
          </p>
        </section>

        {/*
         * SMS & PHONE NUMBERS.
         *
         * Required for US A2P 10DLC messaging registration: a reviewer opens
         * this page and checks that the texting being registered is actually
         * described here — what the number is used for, the legal basis, who
         * it is shared with, how to opt out, and that the controller named
         * matches the registered entity. Its absence is one of the most common
         * rejection reasons, so this section must not be removed or reworded
         * without checking the registration still holds.
         *
         * Placed beside sharing and retention because it references both.
         */}
        <section data-id="element-11373" data-mp="1kfdh5crkkkfo">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11374" data-mp="1kfvbg3uo8oky">
            7.5 SMS &amp; Phone Numbers
          </h2>
          <p className="mb-4" data-id="element-11375" data-mp="3dvq6s0fkhvc1">
            We collect your phone number when you provide it (for example,
            through our website forms) and use it to deliver the service or
            information you requested, to send you SMS messages you have
            consented to — including booking confirmations and reminders,
            follow-ups about your enquiry and, where you opt in, promotional
            messages — and to meet our legal obligations.
          </p>
          <p className="mb-4" data-id="element-11376" data-mp="2zy1o8z8z30a5">
            Our legal bases are: your consent for marketing text messages (which
            you can withdraw at any time), and the performance of a contract or
            our legitimate interests for service-related messages. We share your
            number only with our messaging and carrier providers who process it
            on our behalf to deliver messages, or where required by law or to
            protect our rights.{' '}
            <strong className="text-[#2B211A]" data-id="element-11377" data-mp="28p859tck1pc0">
              We do not sell your phone number.
            </strong>
          </p>
          {/*
           * THE CARRIER'S REQUIRED SENTENCE, VERBATIM AND ON ITS OWN.
           * The registration reviewer looks for this exact string, so it is
           * set apart rather than folded into the paragraph above where a
           * later edit could quietly reword it. Do not paraphrase.
           */}
          <p className="mb-4 rounded-xl border border-[#EFE7DA] bg-[#FAF8F4] p-4" data-id="element-11378" data-mp="1pxfem5kykg7g">
            Text messaging originator opt-in data and consent will not be shared
            with any third parties or affiliates for marketing/promotional
            purposes.
          </p>
          <p className="mb-4" data-id="element-11379" data-mp="1c1v5u2yy1edr">
            You can opt out of SMS at any time by replying{' '}
            <strong className="text-[#2B211A]" data-id="element-11380" data-mp="3bcmkda2dyuyq">STOP</strong>, or by emailing{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-11381" data-mp="36f32m06hc021">
              support@getgiga.com
            </a>
            . We process opt-out requests promptly. Where you opt out of
            marketing messages, we will stop sending those; we may still send
            service-related messages where permitted by law.
          </p>
          <p className="mb-4" data-id="element-11382" data-mp="3lg9yxhzoeers">
            We retain your phone number for as long as needed for the purposes
            described above or as required by law.
          </p>
          <p className="rounded-xl border border-[#EFE7DA] bg-[#FAF8F4] p-4 text-[15px]" data-id="element-11383" data-mp="h2uyjfhmpoyb">
            <strong className="text-[#2B211A]" data-id="element-11384" data-mp="h0iij7vflonw">Controller:</strong> Tonic Labs
            Limited, Ireland ·{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-11385" data-mp="81wu4w3a3ff7">
              support@getgiga.com
            </a>{' '}
            · Our lead supervisory authority is the Irish Data Protection
            Commission.
          </p>
        </section>

        <section data-id="element-11386" data-mp="2l8v40zsakn1u">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11387" data-mp="2l8d9q8p6wiwk">
            8. Data Retention &amp; Deletion
          </h2>
          <p className="mb-4" data-id="element-11388" data-mp="2gbwb2kkd6m58">
            We retain your data for as long as your account is active or as needed
            to provide the Service. When you disconnect an integration, we stop
            accessing that data. When you delete your account, we delete or
            anonymise your data within 30 days, unless we are required by law to
            retain it. To request deletion at any time, contact{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-11389" data-mp="2bap24i6hjgwz">
              support@getgiga.com
            </a>
            .
          </p>
        </section>

        <section data-id="element-11390" data-mp="1iueeko9qcku2">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11391" data-mp="1itw7sxpfyo7w">
            9. International Data Transfers
          </h2>
          <p className="mb-4" data-id="element-11392" data-mp="1dv1ire0vs3fc">
            We are based in Ireland (EU). Some of our service providers (including
            Anthropic) are located outside the European Economic Area, so your data
            may be transferred to and processed in countries whose data-protection
            laws differ from your own. Where we transfer personal data outside the
            EEA or UK, we rely on appropriate safeguards such as the European
            Commission&apos;s Standard Contractual Clauses or an adequacy decision.
          </p>
        </section>

        <section data-id="element-11393" data-mp="1g95qxgatui6s">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11394" data-mp="1g8me2e01ajzm">
            10. Your Privacy Rights (GDPR &amp; UK GDPR)
          </h2>
          <p className="mb-4" data-id="element-11395" data-mp="1q0a182pk5eva">
            If you are in the EEA or UK, you have the right to access, rectify,
            erase, restrict, or object to the processing of your personal data; the
            right to data portability; and the right to withdraw consent at any
            time. To exercise any of these rights, contact{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-11396" data-mp="3khjt1dvtj0jz">
              support@getgiga.com
            </a>
            .
          </p>
          <p className="mb-4" data-id="element-11397" data-mp="3aikl5xivn8y1">
            You also have the right to lodge a complaint with a supervisory
            authority. Our lead authority is the Irish{' '}
            <a href="https://www.dataprotection.ie" className="text-[#EA580C] hover:underline font-medium" target="_blank" rel="noopener noreferrer" data-id="element-11398" data-mp="71lwtb8ekydr">
              Data Protection Commission
            </a>
            , though you may also contact the authority in your own country.
          </p>
        </section>

        <section data-id="element-11399" data-mp="3oic5efzzllkh">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11400" data-mp="3ogspwrm5nejr">
            11. Your Privacy Rights (California / CCPA)
          </h2>
          <p className="mb-4" data-id="element-11401" data-mp="l0bscmfkqq00">
            If you are a California resident, you have the right to know what
            personal information we collect and how it is used; to request
            deletion or correction of your personal information; and to
            non-discrimination for exercising these rights. We do{' '}
            <strong data-id="element-11402" data-mp="22lsoyuz4ffsz">not</strong> sell your personal information, and we do not share
            it for cross-context behavioural advertising. To make a request,
            contact{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-11403" data-mp="2ub47o72s43ix">
              support@getgiga.com
            </a>
            .
          </p>
        </section>

        <section data-id="element-11404" data-mp="2litvwlc8jpzk">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11405" data-mp="2liapa0s1co0u">
            12. Legal Disclosures
          </h2>
          <p className="mb-4" data-id="element-11406" data-mp="3e069pqykvf4s">
            We may disclose your personal data if we believe in good faith that it
            is necessary to comply with a legal obligation, respond to valid
            requests by public authorities (such as a court or government agency),
            protect the rights, property, or safety of Giga, our users, or the
            public, or investigate possible wrongdoing in connection with the
            Service.
          </p>
        </section>

        <section data-id="element-11407" data-mp="3ql4x98pls7m5">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11408" data-mp="3uk3yojc4lm8u">
            13. Children&apos;s Privacy
          </h2>
          <p className="mb-4" data-id="element-11409" data-mp="3djad7dggsfi">
            The Service is not directed to children under 16, and we do not
            knowingly collect personal data from them. If you believe a child has
            provided us personal data, contact us and we will delete it.
          </p>
        </section>

        <section data-id="element-11410" data-mp="i1nnzwxnidrf">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11411" data-mp="i25t7j2ak2bh">
            14. Changes to This Policy
          </h2>
          <p className="mb-4" data-id="element-11412" data-mp="r2vie3x1qug8">
            We may update this Privacy Policy from time to time. We will notify you
            of any material changes by email or through the Service.
          </p>
        </section>

        <section data-id="element-11413" data-mp="2j67w6sfwoee1">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-11414" data-mp="2j6rgugwxxgvr">
            15. Contact Us
          </h2>
          <p data-id="element-11415" data-mp="2s5v0bm00ryas">
            If you have questions or comments about this Privacy Policy, or wish to
            exercise your rights, contact us at{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-11416" data-mp="36tg4zkcjm5kt">
              support@getgiga.com
            </a>
            {' '}or by post to Tonic Labs Limited, Ireland.
          </p>
        </section>

        <section className="pt-8 border-t border-neutral-200/60" data-id="element-11417" data-mp="3awcn79y67zo8">
          <p className="text-sm text-neutral-500" data-id="element-11418" data-mp="3ax5m5oqw1kvt">Last updated: September 2026</p>
          <p className="text-sm text-neutral-500 mt-1" data-id="element-11419" data-mp="1li7lc4cwi3u7">
            © 2026 Tonic Labs Limited. All rights reserved.
          </p>
        </section>
      </div>
    </div>;
}